import * as React from 'react'
// @ts-ignore
import { Button, List, Header } from 'relevant-ui'
import Input from '@App/components/blocks/Input'
import { withTranslation } from 'react-i18next'
import SVG from 'react-inlinesvg'
import FormatText from '@App/helpers/formatText'
// @ts-ignore
import SEARCH from 'assets/search.svg'

const HeaderPage = (props) => {
  const component: any = []

  if (props.onChange) {
    component.push(
      <Input
        label={props.search}
        color="#979797"
        icon={<SVG src={FormatText.formatSVGBase64(SEARCH)} />}
        onChange={(e: any) => props.onChange(e)}
        withoutBorder
        secondary
      />,
    )
  } else {
    component.push(<div></div>)
  }
  return (
    <Header
      components={[
        ...component,
        <Button
          label={props.button}
          size="large"
          type="submit"
          button="primary"
          onClick={props.onClick}
        />,
      ]}
    />
  )
}

export default withTranslation()(HeaderPage)
